import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from "react";
export function ChartsProvider(props) {
    const { children, chartsTheme, enablePinning = false } = props;
    const ctx = useMemo(()=>{
        return {
            chartsTheme,
            enablePinning
        };
    }, [
        chartsTheme,
        enablePinning
    ]);
    return /*#__PURE__*/ _jsx(ChartsThemeContext.Provider, {
        value: ctx,
        children: children
    });
}
export const ChartsThemeContext = /*#__PURE__*/ createContext(undefined);
export function useChartsContext() {
    const ctx = useContext(ChartsThemeContext);
    if (ctx === undefined) {
        throw new Error('No ChartsThemeContext found. Did you forget a Provider?');
    }
    return ctx;
}
export function useChartsTheme() {
    const ctx = useChartsContext();
    return ctx.chartsTheme;
}
export function useContainerPadding() {
    const ctx = useChartsContext();
    return {
        containerPadding: ctx.chartsTheme.container.padding
    };
}

//# sourceMappingURL=ChartsProvider.js.map